import React from 'react';
import { useAppContext } from '../contexts/AppContext';
import { translations } from '../utils/translations';

const SearchBar = () => {
  const { search, setSearch, language, darkMode } = useAppContext();
  const t = translations[language];

  return (
    <div className="mb-3 row justify-content-center">
      <div className="col-md-6">
        <style>{`
          .searchbar-dark::placeholder {
            color: #bbb !important;
            opacity: 1;
          }
        `}</style>
        <input
          type="text"
          className={`form-control${darkMode ? ' bg-dark text-white border-secondary searchbar-dark' : ''}`}
          placeholder={t.searchPlaceholder}
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={darkMode ? { backgroundColor: '#222', color: '#fff', borderColor: '#444' } : {}}
        />
      </div>
    </div>
  );
};

export default SearchBar;
